<template>
  <v-dialog
    :value="value"
    max-width="520"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="headline">
        {{ editingId ? "Rediger gavekorttype" : "Ny gavekorttype" }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="formRef"
          lazy-validation
        >
          <v-text-field
            v-model="localForm.name"
            label="Navn"
            outlined
            dense
          />
          <v-text-field
            v-model.number="localForm.value"
            label="Verdi"
            type="number"
            outlined
            dense
          />
          <v-text-field
            v-model="localForm.currency"
            label="Valuta"
            outlined
            dense
          />
          <v-text-field
            v-model.number="localForm.durationDays"
            label="Varighet i dager (valgfritt)"
            type="number"
            outlined
            dense
          />
          <v-switch
            v-model="localForm.isActive"
            label="Aktiv"
            inset
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="$emit('input', false)"
        >
          Avbryt
        </v-btn>
        <v-btn
          color="primary"
          @click="handleSave"
        >
          {{ editingId ? "Oppdater" : "Opprett" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IGiftCardTypeDTO } from "@shared/types";

interface GiftCardTypeForm {
  id: number | null;
  name: string;
  value: number;
  currency: string;
  durationDays: number | null;
  isActive: boolean;
}

@Component({
  name: "gift-card-type-dialog",
})
export default class GiftCardTypeDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: null }) editingId!: number | null;
  @Prop({ required: true }) formData!: GiftCardTypeForm;

  public localForm: GiftCardTypeForm = {
    id: null,
    name: "",
    value: 0,
    currency: "NOK",
    durationDays: null,
    isActive: true,
  };

  @Watch("formData", { immediate: true, deep: true })
  onFormDataChange(val: GiftCardTypeForm) {
    this.localForm = { ...val };
  }

  public handleSave(): void {
    this.$emit("save", this.localForm);
  }
}
</script>
